import { action, flow, makeObservable, observable } from 'mobx';
import { GlobalStore } from '@roc/feature-app-core';
import { TitleCommitmentService } from '../service/titleCommitmentService';
import { FileUpload } from '@roc/ui';
import { LienRow } from '../types';

export class LienResolutionStore {
  globalStore: GlobalStore;
  private titleCommitmentService: TitleCommitmentService;

  currentLien: LienRow | null;
  comments: string;
  uploads: FileUpload[];

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.titleCommitmentService = new TitleCommitmentService();
    this.currentLien = null;
    this.comments = '';
    this.uploads = [];

    makeObservable(this, {
      currentLien: observable,
      comments: observable,
      uploads: observable,
      setComments: action,
      setUploads: action,
      reset: action,
      getLienByTaskId: flow,
    });
  }

  setComments(value: string) {
    this.comments = value;
  }

  setUploads(uploads: FileUpload[]) {
    this.uploads = uploads;
  }

  reset() {
    this.comments = '';
    this.uploads = [];
    this.currentLien = null;
  }

  *getLienByTaskId(taskId: number) {
    try {
      const response = yield this.titleCommitmentService.getLienByTaskId(taskId);
      this.currentLien = response?.data ?? null;
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while fetching lien details',
      });
    }
  }
}
